<template>
    <html>

    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link rel="icon" type="image/png" href="favicon.png" />
        <title>Restó APP</title>
    </head>

    <body class="home-page">
        <Header :isRestoCompleto=true ></Header>

        <div class="col-lg-8 mx-auto p-3 py-md-5">
            <main>
                <h3>Visualizar Reserva</h3>

                <hr class="" />
                <div class="form-group mb-3">
                    <label class="form-label">Nombre</label><input v-model="nombre" type="text" class="form-control"
                        disabled />
                </div>
                <div class="form-group mb-3">
                    <label class="form-label">Apellido</label><input v-model="apellido" type="text" class="form-control"
                        disabled />
                </div>
                <div class="form-group mb-3">
                    <label class="form-label">Email</label><input v-model="email" type="text" class="form-control"
                        disabled />
                </div>
                <div class="form-group mb-3">
                    <label class="form-label">Teléfono</label><input v-model="telefono" type="text" class="form-control"
                        disabled />
                </div>
                <div class="mb-4 row">
                    <label class="col-sm-3 col-form-label">Comensales</label>
                    <div class="col-sm-3">
                        <label class="form-label">Mayores</label>
                        <input v-model="cantidad_mayor" type="text" class="form-control" disabled />
                    </div>
                    <div class="col-sm-3">
                        <label class="form-label">Menores</label>
                        <input v-model="cantidad_menor" type="text" class="form-control" disabled />
                    </div>
                </div>

                <div class="form-group mb-3">
                    <label class="form-label">Fecha</label><input v-model="fecha" type="text" class="form-control"
                        disabled />
                </div>
                <div class="form-group mb-3">
                    <label class="form-label">Horario</label><input v-model="horario" type="text" class="form-control"
                        disabled />
                </div>
                <div class="col-lg-8 mx-auto p-3 py-md-5">
                    <h5>Calificaciones</h5>

                    <hr class="" />
                    <table class="table table-responsive table-striped align-middle">
                        <thead>
                            <tr>
                                <th scope="col">Nro</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Calificacion</th>
                                <th scope="col">Comentario</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="calificaciones.length == 0">
                                <td colspan="11">
                                    <h4 class="text-center">NO DATA</h4>
                                </td>
                            </tr>
                            <tr v-for="(calificacion, index) in calificaciones" :key="index">
                                <th scope="row">{{ index }}</th>
                                <th scope="row">{{ calificacion.fecha }}</th>
                                <th scope="row">{{ calificacion.calificacion }}</th>
                                <th scope="row">{{ calificacion.descripcion }}</th>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <button type="button" class="btn btn-primary mb-3" style="margin: 0 !important"
                    v-on:click="incumplida()">
                    Incumplida
                </button>
                <br>
                <br>
                <button type="button" class="btn btn-primary mb-3" style="margin: 0 !important"
                    v-on:click="goToPage('Reservas')">
                    Ir a reservas
                </button>
                <PopUpIncumplida :show="showAlertIncumplida" @ok="confirmarIncumplida" @close="cancelarIncumplida">
                     <template #body>
                         <p>¿Desea marcar como incumplida la reserva?</p>
                     </template>
                </PopUpIncumplida>
                <PopUp :show="success" @close="success = false">
                    <template #body>
                        <p>{{ success_msg }}</p>
                    </template>
                </PopUp>
                <PopUp :show="error" @close="error = false">
                    <template #body>
                        <p>{{ error_msg }}</p>
                    </template>
                </PopUp>

                <Footer />
            </main>
        </div>
    </body>

    </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";

import PopUp from "../components/PopUp.vue";
import PopUpIncumplida from "../components/PopUpIncumplida.vue";
import Footer from "../components/Footer.vue";
import "vue2-datepicker/index.css";

export default {
    name: "VerReservaManual",
    components: { Header, Footer, PopUp, PopUpIncumplida },
    data: function () {
        return {
            nombre: "",
            reserva_id: "",
            calificaciones: [],
            resto_id: "",
            apellido: "",
            email: "",
            telefono: "",
            horario: "",
            fecha: "",
            cantidad_mayor: "",
            cantidad_menor: "",
            estado: "",
            error: false,
            success: false,
            error_msg: "",
            success_msg: "",
            showAlertIncumplida: false,
        };
    },

    methods: {
        goToPage(page) {
            this.$router.push({ name: page });
        },
        incumplida() {
        this.showAlertIncumplida = true;
      },

    confirmarIncumplida() {
      let json = {
        id: this.reserva_id,
        
      };

      axios.post("/incumplida", json).then((data) => {
        if (data.status == 200) {
          this.success = true;
          this.success_msg = "Reserva marcada como incumplida de forma exitosa";
        } else {
          console.log("chau");
          this.error = true;
          this.error_msg = "No se ha podido marcar la reserva como incumplida";
        }
      });

      this.showAlertIncumplida = false;
    },

    cancelarIncumplida() {
      this.showAlertIncumplida = false;
    },
  
        // incumplida() {
        //     if (confirm("Desea marcar como incumplida la reserva?")) {
        //         let json = {
        //             id: this.reserva_id
        //         }
        //         axios.post("/incumplida", json).then((data) => {
        //             if (data.status == 200) {
        //                 this.success = true;
        //                 this.success_msg = "Reserva marcada como incumplida de forma exitosa";
        //             } else {
        //                 console.log("chau");
        //                 this.error = true;
        //                 this.error_msg = "No se ha podido marcar la reserva como incumplida";
        //             }
        //         })
        //     }

        // }
    },
    beforeMount() {
        this.reserva_id = localStorage.getItem("reserva_id");
        axios.get("/getReserva/" + this.reserva_id).then((data) => {
            if (data.status == 200) {
                this.resto_id = data.data.restaurante_id;
                if (data.data.usuarioNoRegistrado != undefined) {
                    this.nombre = data.data.usuarioNoRegistrado.nombre;
                    this.apellido = data.data.usuarioNoRegistrado.apellido;
                    this.email = data.data.usuarioNoRegistrado.email;
                    this.telefono = data.data.usuarioNoRegistrado.telefono;
                } else {
                    this.nombre = data.data.usuario.nombre;
                    this.apellido = data.data.usuario.apellido;
                    this.email = data.data.usuario.mail;
                    this.telefono = data.data.usuario.telefono;
                }
                this.cantidad_mayor = data.data.comensales_mayores;
                this.fecha = data.data.fecha;
                this.horario = data.data.horario + "hrs";
                this.cantidad_menor = data.data.comensales_menores;

                axios.get("/calificaciones/" + this.email).then((dataCa)=>{
            if(dataCa.status == 200){
                this.calificaciones = dataCa.data;
            } else {
                this.error = true;
                this.error_msg = "No se ha podido cargar las calificaciones del usuario";
            }
        })


            } else {
                this.error = true;
                this.error_msg = "No se ha podido cargar la reserva";
            }
        });

       
    },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
    --main-color: #0047b3;
    --second-color: #0198f3;
    --grey-color: #f5f8fa;
    --border-radius-1: 9px;
    --border-radius-2: 6px;
}

body {
    font-family: "Inter", sans-serif;
    color: #083744;
    font-size: 14px;
    height: 100%;
}
</style>
